import {MedicalReportTextArea} from '@/features/medical-reports/components/medical-report-text-area/MedicalReportTextArea'
import {REPORT_TEXTAREA_LIMIT} from '@/features/medical-reports/formSchemas'
import {PlannedAccessesFieldsSchema} from '@/features/planned-accesses/formSchemas'
import {useTranslation} from '@/translations/i18n'
import {useController, useFormContext} from 'react-hook-form'
import {z} from 'zod'

const PlannedAccessesAdditionalNotesFieldSchema = PlannedAccessesFieldsSchema.pick({
    additionalNotes: true
})
type PlannedAccessesAdditionalNotesFieldSchema = z.infer<typeof PlannedAccessesAdditionalNotesFieldSchema>

export const PlannedAccessesAdditionalNotesField = () => {
    const {t} = useTranslation()
    const {control} = useFormContext<PlannedAccessesAdditionalNotesFieldSchema>()
    const {field, fieldState} = useController({name: 'additionalNotes', control})

    return (
        <MedicalReportTextArea
            rows={4}
            maxLength={REPORT_TEXTAREA_LIMIT}
            title={t('medical_records:additional_notes')}
            placeholder={t('commons:description_dot')}
            errorMessage={fieldState.error?.message}
            currentField="additionalNotes"
            onChange={field.onChange}
            value={field.value}
        />
    )
}
